/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    blockquote: "blockquote",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "设计任何组件的样式(Styling any component)"
    }), "\n", _jsx(_components.p, {
      children: "¥Styling any component"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "styled"
      }), " 方法可以在你自己的所有组件或任何第三方组件上完美运行，只要它们将传递的 ", _jsx(_components.code, {
        children: "className"
      }), " 属性附加到 DOM 元素即可。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The ", _jsx(_components.code, {
        children: "styled"
      }), " method works perfectly on all of your own or any third-party component, as long as they attach the passed ", _jsx(_components.code, {
        children: "className"
      }), " prop to a DOM element."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["如果你使用 ", _jsx(_components.code, {
          children: "react-native"
        }), "，请记住使用 ", _jsx(_components.code, {
          children: "style"
        }), " 而不是 ", _jsx(_components.code, {
          children: "className"
        }), "。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥If you are using ", _jsx(_components.code, {
          children: "react-native"
        }), " keep in mind to use ", _jsx(_components.code, {
          children: "style"
        }), " instead of ", _jsx(_components.code, {
          children: "className"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// This could be react-router-dom's Link for example\nconst Link = ({ className, children }) => (\n  <a className={className}>\n    {children}\n  </a>\n);\n\nconst StyledLink = styled(Link)`\n  color: #BF4F74;\n  font-weight: bold;\n`;\n\nrender(\n  <div>\n    <Link>Unstyled, boring Link</Link>\n    <br />\n    <StyledLink>Styled, exciting Link</StyledLink>\n  </div>\n);\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["你还可以将标签名称传递到 ", _jsx(_components.code, {
          children: "styled()"
        }), " 工厂调用中，如下所示：", _jsx(_components.code, {
          children: "styled(\"div\")"
        }), "。事实上，", _jsx(_components.code, {
          children: "styled.tagname"
        }), " 助手只是做同样事情的别名。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥You can also pass tag names into the ", _jsx(_components.code, {
          children: "styled()"
        }), " factory call, like so: ", _jsx(_components.code, {
          children: "styled(\"div\")"
        }), ". In fact, the ", _jsx(_components.code, {
          children: "styled.tagname"
        }), " helpers are just aliases that do the same."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
